module.exports = __webpack_public_path__ + "static/media/emptyInsightPage.5a190da8.svg";